"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Mon Aug 06 2018
*/

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Constraints allow or reduce the price change by defining price range for product. Constraint are very important for price calculation.
 * There are some constraint that are used for price with/without constraint a there can be multiple multiple constraints defined for a
 * single product.
 *
 * @author RV
 */


var Constraint =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Constraint, _DomainObject_1$Domai);

  function Constraint() {
    _classCallCheck(this, Constraint);

    return _possibleConstructorReturn(this, _getPrototypeOf(Constraint).apply(this, arguments));
  }

  return Constraint;
}(DomainObject_1.DomainObject);

exports.Constraint = Constraint;